export default __webpack_public_path__ + "static/media/gallery_02.f0163ea7.jpg";